module.exports = __webpack_public_path__ + "img/montecarlo-box.50da68ed.png";